/* DEM PADEL — animations + dialogs + delivery + pay + image lightbox with pan/zoom */
(function(){
  if(!('IntersectionObserver' in window))return;
  const obs=new IntersectionObserver((entries)=>{
    entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-visible');obs.unobserve(e.target)}});
  },{threshold:.12,rootMargin:'0px 0px -60px 0px'});
  const targets='.pdp-block,.section,.product-card,.testi__card,.pour-qui__card,.specs,.dur-mini,.bundle,.partners,.durability,.quiz-teaser,.club,.newsletter,.testi,.usp-bar__item,.pdp__usps > *,.split__media,.split__text';
  function attach(){
    document.querySelectorAll(targets).forEach(el=>{
      if(el.hasAttribute('data-animate'))return;
      el.setAttribute('data-animate','');
      obs.observe(el);
    });
  }
  if(document.readyState!=='loading')attach();else document.addEventListener('DOMContentLoaded',attach);

  function bindDialogs(){
    document.querySelectorAll('[data-info-open]').forEach(btn=>{
      if(btn.__bound)return;btn.__bound=true;
      btn.addEventListener('click',()=>{const id=btn.getAttribute('data-info-open');const dlg=document.getElementById('info-'+id);if(!dlg)return;if(typeof dlg.showModal==='function')dlg.showModal();else dlg.setAttribute('open','')});
    });
    document.querySelectorAll('[data-info-close]').forEach(btn=>{
      if(btn.__bound)return;btn.__bound=true;
      btn.addEventListener('click',()=>{const dlg=btn.closest('dialog');if(!dlg)return;if(typeof dlg.close==='function')dlg.close();else dlg.removeAttribute('open')});
    });
    document.querySelectorAll('dialog.info-dialog').forEach(dlg=>{
      if(dlg.__bound)return;dlg.__bound=true;
      dlg.addEventListener('click',(e)=>{const r=dlg.querySelector('.info-dialog__content').getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom){if(typeof dlg.close==='function')dlg.close();else dlg.removeAttribute('open')}});
    });
  }
  if(document.readyState!=='loading')bindDialogs();else document.addEventListener('DOMContentLoaded',bindDialogs);

  function enhancePay(){
    document.querySelectorAll('.pdp__pay').forEach(el=>{
      if(el.__enhanced)return;el.__enhanced=true;
      let h=el.innerHTML;
      h=h.replace(/^Ou\s+/i,'Paye en ');
      h=h.replace(/avec\s+Klarna\s*\/\s*Alma/i,'avec <span class="pdp__pay-brands"><span class="pdp__pay-brand">Klarna</span><span class="pdp__pay-brand">Alma</span></span>');
      el.innerHTML=h;
    });
  }
  if(document.readyState!=='loading')enhancePay();else document.addEventListener('DOMContentLoaded',enhancePay);

  const FR_HOLIDAYS=new Set([
    '2026-01-01','2026-04-06','2026-05-01','2026-05-08','2026-05-14','2026-05-25','2026-07-14','2026-08-15','2026-11-01','2026-11-11','2026-12-25',
    '2027-01-01','2027-03-29','2027-05-01','2027-05-06','2027-05-08','2027-05-17','2027-07-14','2027-08-15','2027-11-01','2027-11-11','2027-12-25',
    '2028-01-01','2028-04-17','2028-05-01','2028-05-08','2028-05-25','2028-06-05','2028-07-14','2028-08-15','2028-11-01','2028-11-11','2028-12-25'
  ]);
  function dateKey(d){return d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0')}
  function isHoliday(d){return FR_HOLIDAYS.has(dateKey(d))}
  function isWeekend(d){return d.getDay()===0||d.getDay()===6}
  function isClosed(d){return isWeekend(d)||isHoliday(d)}
  function nextOpenDay(d){do{d.setDate(d.getDate()+1)}while(isClosed(d));return d}
  function pushToOpenDay(d){while(isClosed(d)){d.setDate(d.getDate()+1)}return d}
  function computeDeliveryDate(){
    const fmt=new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Paris',year:'numeric',month:'2-digit',day:'2-digit',hour:'numeric',hour12:false});
    const parts=fmt.formatToParts(new Date());
    const get=t=>parts.find(p=>p.type===t).value;
    const y=parseInt(get('year')),m=parseInt(get('month'))-1,dd=parseInt(get('day')),hh=parseInt(get('hour'));
    let d=new Date(y,m,dd);
    const beforeCutoff=!isClosed(d)&&hh<15;
    if(!beforeCutoff)nextOpenDay(d);
    d.setDate(d.getDate()+2);
    pushToOpenDay(d);
    return{date:d,beforeCutoff:beforeCutoff,parisHour:hh}
  }
  function frenchDate(d){
    const days=['dimanche','lundi','mardi','mercredi','jeudi','vendredi','samedi'];
    const months=['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'];
    return days[d.getDay()]+' '+d.getDate()+' '+months[d.getMonth()]
  }
  function injectDelivery(){
    const anchors=document.querySelectorAll('.pdp__same-day');
    if(!anchors.length)return;
    const info=computeDeliveryDate();
    const dateStr=frenchDate(info.date);
    const noteHtml=info.beforeCutoff?'<span class="pdp__delivery-note">Commande avant 15h aujourd\'hui</span>':'';
    anchors.forEach(anchor=>{
      if(anchor.nextElementSibling&&anchor.nextElementSibling.classList&&anchor.nextElementSibling.classList.contains('pdp__delivery'))return;
      const html='<p class="pdp__delivery"><span class="pdp__delivery-icon">🚚</span><span>Reçois ta commande dès <strong>'+dateStr+'</strong>'+noteHtml+'</span></p>';
      anchor.insertAdjacentHTML('afterend',html);
    });
  }
  if(document.readyState!=='loading')injectDelivery();else document.addEventListener('DOMContentLoaded',injectDelivery);

  /* Image lightbox with pan/zoom */
  function initLightbox(){
    if(!document.querySelector('.pdp-gallery'))return;
    if(document.querySelector('.pdp-lightbox'))return;
    const dlg=document.createElement('dialog');
    dlg.className='pdp-lightbox';
    dlg.innerHTML='<button class="pdp-lightbox__close" data-close aria-label="Fermer" type="button"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"/><line x1="6" y1="18" x2="18" y2="6"/></svg></button><button class="pdp-lightbox__prev" data-prev aria-label="Précédente" type="button"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg></button><button class="pdp-lightbox__next" data-next aria-label="Suivante" type="button"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></button><div class="pdp-lightbox__stage" data-stage><img class="pdp-lightbox__img" data-img alt="" draggable="false"></div><div class="pdp-lightbox__counter" data-counter></div><div class="pdp-lightbox__hint">Clique sur la photo pour zoomer • glisse pour explorer • ← → changer • Échap fermer</div>';
    document.body.appendChild(dlg);
    const stage=dlg.querySelector('[data-stage]');
    const img=dlg.querySelector('[data-img]');
    const counter=dlg.querySelector('[data-counter]');
    const prevBtn=dlg.querySelector('[data-prev]');
    const nextBtn=dlg.querySelector('[data-next]');
    let images=[];let idx=0;
    /* Pan state */
    let isPanning=false,panMoved=false,panStartX=0,panStartY=0,panStartScrollX=0,panStartScrollY=0;

    function update(){
      img.src=images[idx]||'';
      img.classList.remove('is-zoomed');
      stage.scrollTo(0,0);
      const multi=images.length>1;
      prevBtn.style.display=multi?'':'none';
      nextBtn.style.display=multi?'':'none';
      counter.style.display=multi?'':'none';
      if(multi)counter.textContent=(idx+1)+' / '+images.length;
    }
    function open(gallery,startIdx){
      const slides=gallery.querySelectorAll('.pdp-gallery__slide img');
      images=[...slides].map(s=>s.getAttribute('data-zoom-src')||s.src);
      idx=Math.max(0,Math.min(startIdx||0,images.length-1));
      update();
      if(typeof dlg.showModal==='function')dlg.showModal();else dlg.setAttribute('open','');
      document.body.style.overflow='hidden';
    }
    function close(){
      if(typeof dlg.close==='function')dlg.close();else dlg.removeAttribute('open');
      img.classList.remove('is-zoomed');
      document.body.style.overflow='';
    }
    function next(){idx=(idx+1)%images.length;update()}
    function prev(){idx=(idx-1+images.length)%images.length;update()}
    function centerZoom(){requestAnimationFrame(()=>{stage.scrollLeft=Math.max(0,(img.scrollWidth-stage.clientWidth)/2);stage.scrollTop=Math.max(0,(img.scrollHeight-stage.clientHeight)/2)})}

    dlg.querySelector('[data-close]').addEventListener('click',close);
    prevBtn.addEventListener('click',prev);
    nextBtn.addEventListener('click',next);
    dlg.addEventListener('click',(e)=>{if(e.target===dlg)close()});

    /* Toggle zoom on click (but ignore if user dragged) */
    img.addEventListener('click',(e)=>{
      e.stopPropagation();
      if(panMoved){panMoved=false;return}
      const wasZoomed=img.classList.toggle('is-zoomed');
      if(wasZoomed)centerZoom();
    });

    /* Mouse pan when zoomed */
    img.addEventListener('mousedown',(e)=>{
      if(!img.classList.contains('is-zoomed'))return;
      if(e.button!==0)return;
      isPanning=true;panMoved=false;
      panStartX=e.clientX;panStartY=e.clientY;
      panStartScrollX=stage.scrollLeft;panStartScrollY=stage.scrollTop;
      img.style.cursor='grabbing';
      e.preventDefault();
    });
    document.addEventListener('mousemove',(e)=>{
      if(!isPanning)return;
      const dx=e.clientX-panStartX;const dy=e.clientY-panStartY;
      if(Math.abs(dx)>3||Math.abs(dy)>3)panMoved=true;
      stage.scrollLeft=panStartScrollX-dx;
      stage.scrollTop=panStartScrollY-dy;
    });
    document.addEventListener('mouseup',()=>{
      if(!isPanning)return;
      isPanning=false;
      img.style.cursor='';
    });

    /* Touch pan when zoomed (single finger) */
    img.addEventListener('touchstart',(e)=>{
      if(!img.classList.contains('is-zoomed'))return;
      if(e.touches.length!==1)return;
      isPanning=true;panMoved=false;
      panStartX=e.touches[0].clientX;panStartY=e.touches[0].clientY;
      panStartScrollX=stage.scrollLeft;panStartScrollY=stage.scrollTop;
    },{passive:true});
    document.addEventListener('touchmove',(e)=>{
      if(!isPanning)return;
      if(e.touches.length!==1){isPanning=false;return}
      const dx=e.touches[0].clientX-panStartX;const dy=e.touches[0].clientY-panStartY;
      if(Math.abs(dx)>5||Math.abs(dy)>5)panMoved=true;
      stage.scrollLeft=panStartScrollX-dx;
      stage.scrollTop=panStartScrollY-dy;
      if(panMoved)e.preventDefault();
    },{passive:false});
    document.addEventListener('touchend',()=>{if(isPanning){isPanning=false;setTimeout(()=>{panMoved=false},50)}});

    /* Mousewheel zoom toggle (anywhere on stage) */
    stage.addEventListener('wheel',(e)=>{
      if(!img.complete)return;
      e.preventDefault();
      if(e.deltaY<0&&!img.classList.contains('is-zoomed')){
        img.classList.add('is-zoomed');
        centerZoom();
      }else if(e.deltaY>0&&img.classList.contains('is-zoomed')){
        img.classList.remove('is-zoomed');
      }
    },{passive:false});

    document.addEventListener('keydown',(e)=>{
      if(!(dlg.open||dlg.hasAttribute('open')))return;
      if(e.key==='Escape')close();
      if(e.key==='ArrowLeft')prev();
      if(e.key==='ArrowRight')next();
    });

    document.querySelectorAll('.pdp-gallery').forEach(gallery=>{
      const slides=gallery.querySelectorAll('.pdp-gallery__slide img');
      slides.forEach((s,i)=>{
        if(s.__zoomBound)return;s.__zoomBound=true;
        s.style.cursor='zoom-in';
        s.addEventListener('click',()=>{const activeSlide=gallery.querySelector('.pdp-gallery__slide.is-active');const activeIdx=activeSlide?parseInt(activeSlide.dataset.slide,10):i;open(gallery,activeIdx)});
      });
      const zoomBtn=gallery.querySelector('[data-zoom-trigger]');
      if(zoomBtn&&!zoomBtn.__bound){zoomBtn.__bound=true;zoomBtn.addEventListener('click',(e)=>{e.preventDefault();const activeSlide=gallery.querySelector('.pdp-gallery__slide.is-active');const activeIdx=activeSlide?parseInt(activeSlide.dataset.slide,10):0;open(gallery,activeIdx)})}
    });
  }
  if(document.readyState!=='loading')initLightbox();else document.addEventListener('DOMContentLoaded',initLightbox);
})();
